import React, { useEffect, useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { Home, Wallet, QrCode, Award, Users, Bell, User } from 'lucide-react';
import api from '@/lib/api';
import { ThemeToggle } from '@/components/ThemeToggle';
import { BrandLogo } from '@/components/BrandLogo';

const leftTabs = [
  { to: '/app', end: true, icon: Home, label: 'Ana Sayfa', testid: 'nav-home' },
  { to: '/app/hakedis', icon: Wallet, label: 'Hakediş', testid: 'nav-earnings' },
];
const rightTabs = [
  { to: '/app/oduller', icon: Award, label: 'Ödüller', testid: 'nav-rewards' },
  { to: '/app/davet', icon: Users, label: 'Davet', testid: 'nav-invite' },
];

const tabClass = ({ isActive }) =>
  `flex flex-col items-center justify-center gap-1 transition-colors ${isActive ? 'text-ink' : 'text-ink-faint'}`;

export default function ArchitectLayout() {
  const navigate = useNavigate();
  const [eventCount, setEventCount] = useState(0);
  useEffect(() => {
    api.get('/architect/notifications').then((r) => {
      const now = Date.now();
      const cnt = (r.data || []).filter((n) => n.type === 'event' && n.eventDate && new Date(n.eventDate).getTime() >= now).length;
      setEventCount(cnt);
    }).catch(() => {});
  }, []);
  return (
    <div className="min-h-screen bg-page flex justify-center">
      <div className="w-full max-w-md bg-page min-h-screen flex flex-col relative">
        {/* Top bar */}
        <header className="sticky top-0 z-20 bg-page/95 backdrop-blur border-b border-line px-5 h-14 flex items-center justify-between">
          <BrandLogo className="text-ink" />
          <div className="flex items-center gap-0.5">
            <ThemeToggle />
            <button
              data-testid="topbar-bell"
              onClick={() => navigate('/app/etkinlikler')}
              className="relative p-2 active:scale-90 transition-transform"
            >
              <Bell strokeWidth={1.25} className="w-5 h-5 text-ink" />
              {eventCount > 0 && (
                <span data-testid="bell-badge" className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 flex items-center justify-center text-[9px] font-semibold text-cream bg-redx rounded-full">
                  {eventCount}
                </span>
              )}
            </button>
            <button
              data-testid="topbar-profile"
              onClick={() => navigate('/app/profil')}
              className="p-2 -mr-2 active:scale-90 transition-transform"
            >
              <User strokeWidth={1.25} className="w-5 h-5 text-ink" />
            </button>
          </div>
        </header>

        <main className="flex-1 pb-24">
          <Outlet />
        </main>

        {/* Bottom nav with center raised QR button */}
        <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-page/95 backdrop-blur border-t border-line z-20">
          <div className="grid grid-cols-5 h-16 items-center">
            {leftTabs.map((t) => (
              <NavLink key={t.to} to={t.to} end={t.end} data-testid={t.testid} className={tabClass}>
                <t.icon strokeWidth={1.5} className="w-5 h-5" />
                <span className="text-[10px] font-medium">{t.label}</span>
              </NavLink>
            ))}

            {/* Center raised QR button */}
            <NavLink to="/app/qr" data-testid="nav-qr" className="flex flex-col items-center justify-center">
              {({ isActive }) => (
                <>
                  <span className={`w-14 h-14 -mt-8 rounded-full flex items-center justify-center border-4 border-page transition-transform active:scale-95 ${isActive ? 'bg-ink' : 'bg-ink'}`}
                    style={{ boxShadow: '0 6px 18px rgb(var(--ink) / 0.28)' }}>
                    <QrCode strokeWidth={1.75} className="w-6 h-6 text-ground" />
                  </span>
                  <span className={`text-[10px] font-medium -mt-1 ${isActive ? 'text-ink' : 'text-ink-faint'}`}>Kodum</span>
                </>
              )}
            </NavLink>

            {rightTabs.map((t) => (
              <NavLink key={t.to} to={t.to} data-testid={t.testid} className={tabClass}>
                <t.icon strokeWidth={1.5} className="w-5 h-5" />
                <span className="text-[10px] font-medium">{t.label}</span>
              </NavLink>
            ))}
          </div>
        </nav>
      </div>
    </div>
  );
}
